<template>
  <div class="filters">
    <el-row class="fiters-box" type="flex" align="middle">
      <el-col class="left">
        <div
          class="label"
          :class="[showFilter ? 'open' : 'close']"
          @click="toggleStatus"
        >
          Filters
        </div>
        <el-popover :placement="placement" v-model="showFilter">
          <div class="box" v-if="type == 'group'">
            <div class="flex">
              <div class="flex-item" v-if="columns1.length > 0">
                <div class="fg list-cats">
                  <div class="fg-nav">{{ columns1_title }}</div>
                  <div class="fg-body">
                    <el-row class="cats" type="flex">
                      <el-col
                        class="subitems"
                        v-for="(cats, idx) in columns1"
                        :key="'cats' + idx"
                      >
                        <div
                          class="subitem"
                          v-for="(cat, idx) in cats"
                          :key="'xx' + idx"
                        >
                          <el-radio v-model="selected_col1" :label="cat.id">{{
                            cat.name
                          }}</el-radio>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
              <div class="flex-item" v-if="columns2.length > 0">
                <div class="fg list-columns">
                  <div class="fg-nav">{{ columns2_title }}</div>
                  <div class="fg-body">
                    <div class="items">
                      <div class="item" v-for="cat in columns2" :key="cat.id">
                        <el-radio v-model="selected_col2" :label="cat.id">{{
                          cat.name
                        }}</el-radio>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="btns">
              <div @click="resetHandler" class="btn reset">Reset</div>
              <div @click="applyHandler" class="btn apply">Apply</div>
            </div>
          </div>
          <div class="box" v-else>
            <el-row :gutter="30" class="simple-items">
              <el-col v-for="item in items" :key="item.id" class="item">
                <div @click="doSimpleSearch(item)">
                  {{ item.name }}
                </div>
              </el-col>
            </el-row>
          </div>
        </el-popover>
      </el-col>
      <el-col class="right"> {{ total }} Results </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "PageFilters",
  data() {
    return {
      selected_col1: "",
      selected_col2: "",
    };
  },
  props: {
    showFilter: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: "group",
    },

    items: {
      type: [Array, Object],
      default: () => [],
    },

    columns1: {
      type: [Array, Object],
      default: () => [],
    },

    columns2: {
      type: [Array, Object],
      default: () => [],
    },

    columns1_title: {
      type: String,
      default: "",
    },

    columns2_title: {
      type: String,
      default: "",
    },

    total: {
      type: [Number, String],
      default: 0,
    },

    placement: {
      type: String,
      default: "right-start",
    },
  },

  methods: {
    // --- ---
    // --- ---
    doSimpleSearch(item) {
      let args = {
        selected_col1: item.id,
      };
      console.log("sear 1", args);
      this.$emit("searchItems", args);
    },

    // --- ---
    // --- ---
    toggleStatus() {
      this.$emit("toggleStatus");
    },

    // --- ---
    // --- ---
    applyHandler() {
      let args = {
        selected_col1: this.selected_col1,
        selected_col2: this.selected_col2,
      };
      this.$emit("searchItems", args);
    },

    // --- ---
    // --- ---
    resetHandler() {
      this.selected_col1 = "";
      this.selected_col2 = "";
      this.$emit("resetItems");
    },
    // --- ---
    // --- ---
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  padding: 45px 85px;
}

.simple-items {
  padding-top: 25px;
  padding-bottom: 25px;
  .item {
    width: 235px;
    text-align: center;
    padding: 0 0;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: #13b0e1;
    }
  }
}

.fg {
  // padding: 45px 85px 15px 85px;

  &.list-brands {
    .subitem {
      width: 100px;
    }
  }

  &-nav {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #3f3f3f;
  }
  &-body {
    margin-top: 35px;

    .item,
    .subitem {
      margin-bottom: 35px;
      width: 235px;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      /* or 125% */

      display: flex;
      align-items: center;

      color: #3f3f3f;
    }
  }
}

.btns {
  position: relative;
  display: flex;
  justify-content: center;
  // padding-top: 35px;
  padding-bottom: 35px;
  .btn {
    width: 190px;
    height: 30px;
    cursor: pointer;
    color: #fff;
    text-align: center;
    line-height: 30px;
    background: #000000;
    transition: all 0.3s ease-in-out;
    &:hover {
      background-color: rgba($color: #000000, $alpha: 0.7);
    }
    &:last-child {
      margin-left: 38px;
    }
  }
}

.filters {
  position: relative;
  margin-top: 117px;
  margin-bottom: 90px;
  .left {
    font-family: "Roboto";
    display: flex;
    padding-left: 210px;

    .filter-inner {
      padding: 20px 60px;
      .cat {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 21px;
      }

      .items {
        flex-wrap: wrap;

        .item {
          margin-top: 35px;
        }
      }
    }

    .label {
      font-style: normal;
      font-weight: 700;
      font-size: 25px;

      background-size: 24px 24px;
      background-repeat: no-repeat;
      padding-right: 30px;
      cursor: pointer;
      background-position-y: center;
      background-position-x: right;

      &.close {
        background-image: url(//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/05/icon-filters.png);
      }
      &.open {
        background-image: url(//leadexv2.weappdev.cn/wp-content/uploads/sites/77/2022/08/icon_surprise.png);
      }
    }
  }
  .right {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    text-align: right;
    padding-right: 210px;
  }
}
</style>
